import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/img/nav/logo_nav.png';
import _imports_1 from '../assets/img/nav/person.png';
const _withScopeId = n => (_pushScopeId("data-v-90d94292"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "nav-header"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = {
  class: "itembox"
};
const _hoisted_6 = {
  key: 0,
  class: "loginbox"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "border-right"
}, null, -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "user-dropdown"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
})], -1));
const _hoisted_9 = {
  key: 0,
  class: "user-dropdown-menu my-meun"
};
const _hoisted_10 = {
  class: "user-dropdown-msgbox"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "user-dropdown-logo"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
})], -1));
const _hoisted_12 = {
  class: "user-name"
};
const _hoisted_13 = {
  class: "user-email"
};
const _hoisted_14 = {
  class: "user-dropdown-operate"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "operate-item-logo"
}, null, -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "operate-item-logo"
}, null, -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "operate-item-logo"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_expired_tip = _resolveComponent("expired-tip");
  const _component_personal = _resolveComponent("personal");
  const _component_update_authorization = _resolveComponent("update-authorization");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "logobox",
    onClick: _cache[0] || (_cache[0] = $event => $setup.goToPage('/'))
  }, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
    class: "item",
    onClick: _cache[1] || (_cache[1] = $event => $setup.goToPage('/'))
  }, [_createElementVNode("p", {
    class: _normalizeClass({
      check: $setup.logoutPage.indexOf($setup.pathNow) === -1 && $setup.pathNow !== '/support'
    })
  }, _toDisplayString(_ctx.$t("message.softwareDownload")), 3)]), _createElementVNode("div", {
    class: "item",
    onClick: _cache[2] || (_cache[2] = $event => $setup.goToPage('/remote', true))
  }, [_createElementVNode("p", {
    class: _normalizeClass({
      check: $setup.pathNow === '/remote'
    })
  }, _toDisplayString(_ctx.$t("message.deviceManagement")), 3)]), _createElementVNode("div", {
    class: "item",
    onClick: _cache[3] || (_cache[3] = $event => $setup.goToPage('/account', true))
  }, [_createElementVNode("p", {
    class: _normalizeClass({
      check: $setup.pathNow === '/account'
    })
  }, _toDisplayString(_ctx.$t("message.accountManagement")), 3)]), _createElementVNode("div", {
    class: "item",
    onClick: _cache[4] || (_cache[4] = $event => $setup.goToPage('/authorization', true))
  }, [_createElementVNode("p", {
    class: _normalizeClass({
      check: $setup.pathNow === '/authorization'
    })
  }, _toDisplayString(_ctx.$t("message.Authorization")), 3)]), _createElementVNode("div", {
    class: "item",
    onClick: _cache[5] || (_cache[5] = $event => $setup.goToPage('/resource', true))
  }, [_createElementVNode("p", {
    class: _normalizeClass({
      check: $setup.pathNow === '/resource'
    })
  }, _toDisplayString(_ctx.$t("message.ResourceDownload")), 3)]), _createElementVNode("div", {
    class: "item",
    onClick: _cache[6] || (_cache[6] = $event => $setup.goToPage('/support', true))
  }, [_createElementVNode("p", {
    class: _normalizeClass({
      check: $setup.pathNow === '/support'
    })
  }, _toDisplayString(_ctx.$t("message.Support")), 3)])]), !$setup.userInfo.email ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", {
    class: "login item",
    onClick: _cache[7] || (_cache[7] = (...args) => $setup.clickLogin && $setup.clickLogin(...args))
  }, _toDisplayString(_ctx.$t("message.siginIn")), 1), _hoisted_7, _createElementVNode("div", {
    class: "register item",
    onClick: _cache[8] || (_cache[8] = (...args) => $setup.clickRegister && $setup.clickRegister(...args))
  }, _toDisplayString(_ctx.$t("message.register")), 1)])) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "userbox",
    onMouseenter: _cache[12] || (_cache[12] = _withModifiers($event => $setup.showUserMenu = true, ["stop"])),
    onMouseleave: _cache[13] || (_cache[13] = _withModifiers($event => $setup.showUserMenu = false, ["stop"]))
  }, [_hoisted_8, $setup.showUserMenu ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("p", _hoisted_12, _toDisplayString($setup.userInfo.name || ""), 1), _createElementVNode("p", _hoisted_13, _toDisplayString($setup.userInfo.email || ""), 1)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", {
    class: "dropdown-operate-item menu-item",
    onClick: _cache[9] || (_cache[9] = _withModifiers((...args) => $setup.updatePassword && $setup.updatePassword(...args), ["stop"]))
  }, [_hoisted_15, _createTextVNode(" " + _toDisplayString(_ctx.$t("message.changePwd")), 1)]), _createElementVNode("div", {
    class: "dropdown-operate-item menu-item",
    onClick: _cache[10] || (_cache[10] = _withModifiers((...args) => $setup.handleClickPersonal && $setup.handleClickPersonal(...args), ["stop"]))
  }, [_hoisted_16, _createTextVNode(" " + _toDisplayString(_ctx.$t("message.PersonalCenter")), 1)]), _createElementVNode("div", {
    class: "dropdown-operate-item menu-item",
    onClick: _cache[11] || (_cache[11] = _withModifiers((...args) => $setup.clickLogout && $setup.clickLogout(...args), ["stop"]))
  }, [_hoisted_17, _createTextVNode(" " + _toDisplayString(_ctx.$t("message.signOut")), 1)])])])) : _createCommentVNode("", true)], 32))])]), _createVNode(_component_expired_tip, {
    modelValue: $setup.showExpiredTip,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $setup.showExpiredTip = $event),
    message: $setup.expirationTip,
    confirm: _ctx.$t('message.Go'),
    onConfirm: $setup.handleClickPersonal
  }, null, 8, ["modelValue", "message", "confirm", "onConfirm"]), _createVNode(_component_personal, {
    modelValue: $setup.showPersonal,
    "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $setup.showPersonal = $event),
    onConfirm: $setup.handleUpdateAuthorization
  }, null, 8, ["modelValue", "onConfirm"]), _createVNode(_component_update_authorization, {
    modelValue: $setup.showUpdateAuthorization,
    "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $setup.showUpdateAuthorization = $event),
    onConfirm: $setup.handleApplicationSubmit
  }, null, 8, ["modelValue", "onConfirm"])], 64);
}